import { EonUiDropdown, EonUiDropdownOption } from "@eon-ui/eon-ui-components-react";

const OnboardingPortalStatusFilter = ({
    t,
    status,
    setStatus,
}: {
    t: (key: string) => string;
    status: string;
    setStatus: (status: string) => void;
}) => {
    return (
        <EonUiDropdown
            label={t("onboardingPortal.tableHeaders.status")}
            size="small"
            value={status}
            onValueChanged={(e) => setStatus(e.target.value)}
            key={status}
        >
            <EonUiDropdownOption
                key={"all"}
                value={"all"}
                label={t(`onboardingPortal.statusLabel.all`)}
            />
            {["pending", "approved", "rejected", "inQA", "inProd"].map((s) => (
                <EonUiDropdownOption
                    key={s}
                    value={s}
                    label={t(`onboardingPortal.statusLabel.${s}`)}
                />
            ))}
        </EonUiDropdown>
    );
};

export default OnboardingPortalStatusFilter;
